const CONTENT = {
  privacy: {
    title: "Privacy notice",
    body: [
      "We take the privacy of our members and prospective members seriously. This notice explains what personal information we collect, why we collect it, and how we look after it.",
      "We collect only the information needed to process membership applications, deliver training, manage events and communicate with you. This may include your name, contact details and information relevant to your driving or riding.",
      "We never sell your data. We do not share driving-related or personal information beyond what is necessary to run the club. Analytics used on this site do not collect sensitive form content or expose personal member information.",
      "You have the right to access, correct or request deletion of your personal data. To do so, contact us at enquiries@rospabikers.club.",
    ],
  },
  accessibility: {
    title: "Accessibility statement",
    body: [
      "We want this website to be usable by as many people as possible, whatever their level of digital confidence.",
      "The site is designed mobile-first, works without relying on hover, provides large touch targets, and respects your device's reduced-motion setting. Content is structured for screen readers and keyboard navigation.",
      "If you experience any difficulty using this website, please contact us at enquiries@rospabikers.club and we will do our best to help and to improve.",
    ],
  },
  terms: {
    title: "Terms of use",
    body: [
      "By using this website you agree to these terms. The information provided is for general guidance about the club and its activities.",
      "Membership, training and events are subject to the club's constitution and policies. Fees and eligibility are confirmed at the point of application.",
      "Advanced training is delivered by volunteers and does not replace your legal responsibility to drive or ride safely and lawfully at all times.",
    ],
  },
  safeguarding: {
    title: "Safeguarding information",
    body: [
      "The club is committed to the safety and wellbeing of all members, including young people and vulnerable adults who take part in our activities.",
      "All volunteers understand their responsibilities and act appropriately at all times. Any safeguarding concern is taken seriously and handled sensitively.",
      "If you have a safeguarding concern, please contact us in confidence at enquiries@rospabikers.club.",
    ],
  },
};

import HeroBackdrop from "../components/HeroBackdrop";
import { useContent } from "../context/ContentContext";

export default function Legal({ page }) {
  const c = CONTENT[page];
  const { t } = useContent();
  return (
    <div data-testid={`legal-${page}-page`}>
      <section className="relative overflow-hidden bg-[#0F2744] py-14">
        <HeroBackdrop sectionKey="legal" image={t("img.legal", "https://images.pexels.com/photos/8112126/pexels-photo-8112126.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600")} />
        <div className="relative z-10 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white">{c.title}</h1>
        </div>
      </section>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-4">
        {c.body.map((p, i) => (
          <p key={i} className="text-slate-600 leading-relaxed text-lg">{p}</p>
        ))}
      </div>
    </div>
  );
}
